module.exports = __webpack_public_path__ + "img/qf_logo.64d710d9.jpg";